// extracted by mini-css-extract-plugin
export var buttons = "style-module--buttons--DQN2p";
export var form = "style-module--form--d3NIN";
export var info_blurb = "style-module--info_blurb--JtMFg";